<div class="modal-body" *ngIf="!isLoading && !allAccessPassStage" style="color: #FFFFFF; padding-top: 40px !important; padding-bottom: 20px !important;">
  
  <b>{{buyModel.name}}</b>
  <p><span class="fa fa-map-marker"></span> {{buyModel.venueName}} </p>
  <p>{{buyModel.ShortDescriptive1}} </p>
  <p>Start watching during CINEJOY festival {{buyModel.dates}} </p>
  <b>Ticket Quantity:</b> 1
  <p>{{buyModel.eventListPricesName}} - {{buyModel.type}} </p>
  <p [ngClass]="{'green-price': buyModel.priceToPick.TicketType !== 'Streaming'}">Price: {{buyModel.basePrice | currency}} </p>
  <b *ngIf="isAlreadyInCart" style="color: #DE1B36;">You have already added this ticket to the cart!</b>
  <b *ngIf="isInvalidPromoCode && isFromPromoCodePopup" style="color: #DE1B36;">Invalid Promo Code Please try again!</b>
</div>

<!-- All Access passes -->

<div class="modal-body" *ngIf="!isLoading && allAccessPassStage" style="color: #FFFFFF; padding-top: 40px !important; padding-bottom: 20px !important;">
  
  <p> <span class="fa fa-map-marker"></span> Cinejoy Passes </p>
  <p> All Access Pass </p>
  <p>Begin using your pass upon purchase (and through the festival) to buy/add tickets for Spotlight Events
     and Showcase Movies. RSVP for Artist & Audience Meetup (or even host Artist & Audience Meetup). Go to My Tickets in the side menu to all
      your events and movies, and then Enjoy Experiencing them during the Cinejoy Festival.</p>
  <b>Ticket Quantity:</b> 1
  <p>{{buyModel.eventListPricesName}} - Festival Pass </p>
  <p [ngClass]="{'green-price': buyModel.priceToPick.TicketType !== 'Streaming'}">Price: {{buyModel.basePrice | currency}} </p>
  <b *ngIf="isAlreadyInCart" style="color: #DE1B36;">You have already added this ticket to the cart!</b>
  <b *ngIf="isInvalidPromoCode && isFromPromoCodePopup" style="color: #DE1B36;">Invalid Promo Code Please try again!</b>
</div>

<div *ngIf="!isLoading" class="modal-footer">
  <button type="button" *ngIf="!isAlreadyInCart" class="btn btn-primary" (click)="addToCart()"
      style="background: #DE1B36 !important; border: 1px red solid; cursor: pointer; color: white; margin-bottom: 10px;">Add Ticket To Cart</button>
  <button type="button" *ngIf="!isAlreadyInCart" class="btn btn-primary" data-toggle="modal" data-target="#promoCodeModalCenter" (click)="openPromoCodePopup()"
      style="background: #DE1B36 !important; border: 1px red solid; cursor: pointer; color: white; margin-bottom: 10px;">Promo Code</button>
  <button type="button" *ngIf="isAlreadyInCart" class="btn btn-primary" (click)="proceedToCart()"
      style="background: #DE1B36 !important; border: 1px red solid; cursor: pointer; color: white; margin-bottom: 10px;">Proceed to cart</button>
  <button type="button" class="btn btn-primary pull-right" (click)="closeModal()" 
      data-dismiss="modal"
      style="background: #DE1B36 !important; border: 1px red solid; cursor: pointer; color: white; margin-bottom: 10px;">Continue Shopping</button>
  </div>
<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>